export const fileExtension = (file: File) => {
  const splitFilename = file.name.split('.')
  const extensionFile = `.${splitFilename.pop()}`
  
  return extensionFile
}
